// extracted by mini-css-extract-plugin
module.exports = {"emoji":"TaskRunsTable_emoji__KCDmC","container":"TaskRunsTable_container__Sc2nD"};